import './imageContainer.css';

export default function ImageContainer({type}) {

    const overlayColor = type ? 'rgba(136, 205, 246, 0.2)' : 'rgba(114, 191, 114, 0.2)';
    const border = type ? '0.6rem solid var(--primary-color-two)' : '0.6rem solid var(--secondary-color-two)';
    const width = type ? '90rem' : '60rem';
    const outlineWidth = type ? '89rem' : '59rem';

    return (
        <div>
            <div className="landing-image-container" style={{
                '--overlay-color': overlayColor,
                '--border-type': border,
                '--img-size': width,
                '--outline-size': outlineWidth
            }}></div>
        </div>
    )
}